import React from 'react';

const worldContext = {
  languages: [],
  currencies: [],
  countries: [],
  vatTypes: [],
};
export default React.createContext(worldContext);
